var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparklesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11632_321796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 12.0013C11.0203 12.0013 11.3594 12.1418 11.6095 12.3918C11.8595 12.6419 12 12.981 12 13.3346C12 12.981 12.1405 12.6419 12.3905 12.3918C12.6406 12.1418 12.9797 12.0013 13.3333 12.0013C12.9797 12.0013 12.6406 11.8608 12.3905 11.6108C12.1405 11.3607 12 11.0216 12 10.668C12 11.0216 11.8595 11.3607 11.6095 11.6108C11.3594 11.8608 11.0203 12.0013 10.6667 12.0013ZM10.6667 4.0013C11.0203 4.0013 11.3594 4.14178 11.6095 4.39183C11.8595 4.64187 12 4.98101 12 5.33464C12 4.98101 12.1405 4.64187 12.3905 4.39183C12.6406 4.14178 12.9797 4.0013 13.3333 4.0013C12.9797 4.0013 12.6406 3.86083 12.3905 3.61078C12.1405 3.36073 12 3.02159 12 2.66797C12 3.02159 11.8595 3.36073 11.6095 3.61078C11.3594 3.86083 11.0203 4.0013 10.6667 4.0013ZM6 12.0013C6 10.9404 6.42143 9.92302 7.17157 9.17288C7.92172 8.42273 8.93913 8.0013 10 8.0013C8.93913 8.0013 7.92172 7.57987 7.17157 6.82973C6.42143 6.07958 6 5.06217 6 4.0013C6 5.06217 5.57857 6.07958 4.82843 6.82973C4.07828 7.57987 3.06087 8.0013 2 8.0013C3.06087 8.0013 4.07828 8.42273 4.82843 9.17288C5.57857 9.92302 6 10.9404 6 12.0013Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11632_321796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesWhite);
export default __webpack_public_path__ + "static/media/sparkles_white.f86d37395cd974e0be1f96558ed816b7.svg";
export { ForwardRef as ReactComponent };